export default {
  CLEAR_CURRENT: 'MESSAGES_CLEAR_CURRENT',
  GET_REQUEST: 'MESSAGES_GET_REQUEST',
  GET_SUCCESS: 'MESSAGES_GET_SUCCESS',
  GET_FAILURE: 'MESSAGES_GET_FAILURE',

  SAVE_REQUEST: 'MESSAGES_SAVER_REQUEST',
  SAVE_SUCCESS: 'MESSAGES_SAVE_SUCCESS',
  SAVE_FAILURE: 'MESSAGES_SAVE_FAILURE',

  GETALL_REQUEST: 'MESSAGES_GETALL_REQUEST',
  GETALL_SUCCESS: 'MESSAGES_GETALL_SUCCESS',
  GETALL_FAILURE: 'MESSAGES_GETALL_FAILURE',

  DELETE_REQUEST: 'MESSAGES_DELETE_REQUEST',
  DELETE_SUCCESS: 'MESSAGES_DELETE_SUCCESS',
  DELETE_FAILURE: 'MESSAGES_DELETE_FAILURE',    

  UPDATE_REQUEST: 'MESSAGES_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'MESSAGES_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'MESSAGES_UPDATE_FAILURE'    

};